import { render, staticRenderFns } from "./ShiftAresGlobalParameters.vue?vue&type=template&id=1b58dd95&"
import script from "./ShiftAresGlobalParameters.vue?vue&type=script&lang=ts&"
export * from "./ShiftAresGlobalParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports